import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import map from 'lodash.map';
import size from 'lodash.size';
import * as Maps from '../../../store/map';
import { lSportsConfig } from '../../../config/lsports.config';
import { Translate } from '../../../localization';

class SportsList extends React.Component {
    selectSport = (sportId) => {
        this.props.lsportsActions.inplay.selectSport(sportId);
    };

    componentDidMount() {
        this.props.lsportsActions.inplay.selectSport(lSportsConfig.prematch.selectedSport);
    }

    render() {
        let { selectedSport, mainEvents } = this.props.lSports.inplay;
        let sportLength = size(mainEvents);

        const sportList = map(mainEvents, (item, i) => {
            let sportId = item.Id;
            let sportName = item.Name;
            let count = item.EventCount;
            let icon = item.Icon;
            let paddingRight = i + 1 === sportLength ? 'pr-2' : '';

            return (
                <div className={'sports-box-col ' + paddingRight} onClick={(e) => this.selectSport(sportId)} key={sportId}>
                    <div className={`sports-box pt-3 ${selectedSport === sportId ? 'active' : ''}`}>
                        <div className="counter"> {count} </div>
                        <i className={'fs-26 ' + icon + ' lh-1p'}></i>
                        <div>{sportName}</div>
                    </div>
                </div>
            );
        });

        return (
            <div className="sport-header pt-2 disable-select">
                <div className="sports-box-row">
                    <Link className="sports-box-col" to="/inplay/search">
                        <div className="sports-box pt-3">
                            <i className="fs-22 mt-2 icon-search lh-1p"></i>
                            <div className="pt-1">{Translate.search}</div>
                        </div>
                    </Link>
                    {sportList}
                </div>
            </div>
        );
    }
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(SportsList);
